import { useState } from "react";
import { useInterval } from "ahooks";
import moment from "moment";

function DatetimeLabel() {
  const [timestamp, setTimestamp] = useState(Date.now());
  useInterval(() => {
    setTimestamp(Date.now());
  }, 1000);
  return (
    <div className="welcome-header-datetime">
      {moment(timestamp).format("YYYY年MM月DD日 HH:mm:ss")}
    </div>
  );
}

export default DatetimeLabel;
